type FlatfinderPerspectiveErrorTranslationKey =
  | 'flatfinderFormImagePreparationFailed'
  | 'flatfinderFormChooseImageFormat'
  | 'flatfinderFormImageReadFailed'
  | 'flatfinderFormImageUploadIncomplete'
  | 'flatfinderFormChooseImage';

export class FlatfinderPerspectiveError extends Error {
  constructor(readonly translationKey: FlatfinderPerspectiveErrorTranslationKey) {
    super(translationKey);
  }
}

export async function prepareFlatfinderPerspectiveImage(file: File) {
  const url = URL.createObjectURL(file);

  try {
    const image = new Image();
    image.src = url;
    await image.decode();

    const dimensions = {
      width: image.naturalWidth,
      height: image.naturalHeight,
    };

    if (!['image/jpeg', 'image/jpg', 'image/webp'].includes(file.type)) {
      return { ...dimensions, file };
    }

    const canvas = document.createElement('canvas');
    canvas.width = dimensions.width;
    canvas.height = dimensions.height;
    const context = canvas.getContext('2d');
    if (!context) throw new FlatfinderPerspectiveError('flatfinderFormImagePreparationFailed');

    // Drawing the decoded image bakes phone-photo orientation into its pixels.
    // The saved dimensions and normalized area points then use the same image.
    context.drawImage(image, 0, 0);
    const blob = await new Promise<Blob>((resolve, reject) =>
      canvas.toBlob(
        (result) =>
          result
            ? resolve(result)
            : reject(new FlatfinderPerspectiveError('flatfinderFormImagePreparationFailed')),
        file.type === 'image/webp' ? 'image/webp' : 'image/jpeg',
        0.95
      )
    );

    return {
      ...dimensions,
      file: new File([blob], file.name, { type: blob.type }),
    };
  } finally {
    URL.revokeObjectURL(url);
  }
}
